import strftime from 'strftime';
import moment from 'moment';
require("moment-duration-format");

export default {

  format_date: function(ts, format = "%d.%m.%Y") {
    var d;
    if (typeof(ts) != "undefined") {
      d = new Date(ts * 1000);
    } else {
      d = new Date();
    }
    return strftime(format, d);
  },
  format_date_with_weekday: function(ts) {
    var d;
    if (typeof(ts) != "undefined") {
      d = new Date(ts * 1000);
    } else {
      d = new Date();
    }
    return strftime("%A %d.%m.%Y", d);
  },
  format_time: function(ts) {
    var d;
    if (typeof(ts) != "undefined") {
      d = new Date(ts * 1000);
    } else {
      d = new Date();
    }
    return strftime("%H:%M", d);
  },
  format_time_seconds: function(ts) {
    var d;
    if (typeof(ts) != "undefined") {
      d = new Date(ts * 1000);
    } else {
      d = new Date();
    }
    return strftime("%H:%M:%S", d);
  },
  format_time_timezone: function(ts) {
    var d;
    if (typeof(ts) != "undefined") {
      d = new Date(ts * 1000);
    } else {
      d = new Date();
    }
    return strftime("%z", d);    
  },
  to_timestamp: function(date_str, time_str) {
    if (typeof(date_str) == "object") {
      date_str = strftime("%d.%m.%Y", date_str);
    }
    if (typeof(time_str) == "object") {
      time_str = strftime("%H:%M", time_str);
    }

    return parseInt(moment(date_str + " " + time_str, "%DD.%MM.%YYYY %HH:%mm").format("X"),10);
  },

  format: function (value, format) {
    var value = moment(value).toDate();
    return strftime(format, value);
  },

  format_duration: function(value, format) {
    return moment.duration(value, "seconds").format(format);
  }

}
